import { useMemo } from 'react'
import { Button, SelectMultiple } from '~/components/ui'
import { STATE_LABELS } from '~/utils'

export default function StateFilter({
  stateValues,
  filterState,
  updateFilter,
}: {
  stateValues: string[]
  filterState: string[]
  updateFilter: (updates: Record<string, any>) => void
}) {
  const stateData = useMemo(
    () =>
      stateValues.map((state) => {
        return { label: STATE_LABELS[state] ?? state, value: state }
      }),
    [stateValues]
  )
  const selectedStates = useMemo(
    () => stateData.filter(({ value }) => filterState.includes(value)),
    [filterState, stateData]
  )

  return (
    <div className="space-y-2">
      <p className="text-sm">
        State
        {selectedStates.length > 0 && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => updateFilter({ states: undefined })}>
            (reset)
          </Button>
        )}
      </p>
      <SelectMultiple
        scrollIntoView
        isPopover={false}
        placeholder="Search states..."
        options={stateData}
        selected={selectedStates}
        setSelected={(selected) => {
          updateFilter({
            states: selected.map(({ value }) => value),
          })
        }}
      />
    </div>
  )
}
